import classNames from "classnames"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import {
  forwardRef,
  useState,
  useMemo,
} from "react"

import styles from "./Input.module.scss"
import { InputIconButtonContext } from "./InputIconButtonContext"

type Props = ComponentPropsWithoutRef<"div">

export const InputWithIconButton = forwardRef<HTMLDivElement, Props>(
  function InputWithIconButton(props: Props, propRef: Ref<HTMLDivElement>) {
    const [
      hasStart,
      setHasStartIcon,
    ] = useState<boolean>(false)

    const [
      hasEnd,
      setHasEndIcon,
    ] = useState<boolean>(false)

    const contextValue = useMemo(
      () => ({
        setHasStartIcon,
        setHasEndIcon,
      }),
      [
        setHasStartIcon,
        setHasEndIcon,
      ],
    )

    const className = classNames(
      props.className,
      styles.inputWithIconButton,
      {
        [styles.inputWithStartIconButton]: hasStart,
        [styles.inputWithEndIconButton]: hasEnd,
      },
    )

    return (
      <InputIconButtonContext.Provider value={contextValue}>
        <div
          {...props}
          className={className}
          ref={propRef}
        >
        </div>
      </InputIconButtonContext.Provider>
    )
  },
)
